import React, {useState} from "react";
import {__} from "services/i18n";
import {TextField} from "features/components/text-field";
import {
    EmailTextFieldValidator, EmailValidator,
    PasswordTextFieldValidator, PasswordValidator,
    PhoneTextFieldValidator, PhoneValidator, RequiredValidator
} from "services/utils/validations";
import PasswordTextField from "features/components/password-text-field";
import {func, string} from "prop-types";
import Checkbox from "features/components/checkbox";

const SignupForm = (props) => {
    const {firstName, lastName, email, phone, password, terms, onChange} = props;
    const [firstNameVal, setFirstName] = useState(firstName);
    const [lastNameVal, setLastName] = useState(lastName);
    const [emailVal, setEmail] = useState(email);
    const [phoneVal, setPhone] = useState(phone);
    const [passwordVal, setPassword] = useState(password);
    const [termsVal, setTerms] = useState(terms);
    React.useEffect(() => {
        onChange({
            firstName: firstNameVal,
            lastName: lastNameVal,
            email: emailVal,
            phone: phoneVal,
            password: passwordVal,
            terms: termsVal,
            valid: RequiredValidator(firstNameVal) && RequiredValidator(lastNameVal) && EmailValidator(emailVal) && PhoneValidator(phoneVal) && PasswordValidator(passwordVal) && RequiredValidator(termsVal)
        })
    }, [firstNameVal, lastNameVal, emailVal, phoneVal, passwordVal, termsVal, onChange]);
    return <>
        <div className={"form-field"}>
            <TextField
                type={"text"}
                value={firstNameVal}
                onChange={setFirstName}
                placeholder={__("text-fields.first-name.placeholder")}
            />
            <TextField
                type={"text"}
                value={lastNameVal}
                onChange={setLastName}
                placeholder={__("text-fields.last-name.placeholder")}
            />
            <TextField
                type={"text"}
                value={emailVal}
                onChange={setEmail}
                placeholder={__("text-fields.email.placeholder-short")}
                validationFunc={EmailTextFieldValidator}
            />
            <TextField
                type={"text"}
                value={phoneVal}
                onChange={setPhone}
                placeholder={__("text-fields.phone.placeholder")}
                validationFunc={PhoneTextFieldValidator}
            />
            <PasswordTextField
                value={passwordVal}
                onChange={setPassword}
                placeholder={__("text-fields.password.placeholder")}
                hint={__("text-fields.password.hint")}
                validationFunc={PasswordTextFieldValidator}
            />
        </div>
        <Checkbox value={termsVal} onChange={setTerms} label={__("text-fields.terms.label")} />
    </>
};

export const SignupBaseState = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    terms: false,
    valid: false
}

SignupForm.propTypes = {
    firstName: string.isRequired,
    lastName: string.isRequired,
    email: string.isRequired,
    phone: string.isRequired,
    password: string.isRequired,
    onChange: func.isRequired
};
export default SignupForm;